module.exports = __webpack_public_path__ + "static/media/4.f76a71d5.jpg";